<template>
  <ul
    v-if="images.length > 0"
    class="list-view"
  >
    <li
      v-for="(image, index) in images"
      :key="index"
    >
      <div v-if="!isLogo && image.showInput" class="checkbox">
        <input
          type="checkbox"
          :name="index"
          :id="index"
          v-model="image.checked"
        />
        <label :for="index"></label>
      </div>
      <div class="box-wrapper">
        <div class="image-wrapper">
          <img
            v-lazy="image.thumbnailUrl"
            :key="image.thumbnailUrl"
            @click="$emit('selectImage', image)"
          />
        </div>
        <div class="info" v-if="mixinIsShowAsync">
          <div v-if="!isLogo" class="id"><span>ID</span>{{ image.code }}</div>
          <div class="name-box">
            <div
              v-if="image.showInput.name"
              key="name"
              class="main-input"
            >
              <input
                type="text"
                v-model="image.filename"
                @keypress.enter="$event.target.blur"
                @blur="$emit('toggleSave', image, 'name', index)"
                :ref="'name' + index"
              />
            </div>
            <div
              v-else
              key="name"
            >
              <span class="name">{{image.filename}}</span>
            </div>
            <span class="pen" v-if="!image.showInput.name" @click="$emit('toggleShowInput', image, 'name', index)"><i class="fas fa-pen"></i></span>
          </div><!-- .nameBox -->
          <div class="alt-box">
            <div
              v-if="image.showInput.alt"
              key="alt"
              class="main-input"
            >
              <input
                type="text"
                :value="image.alt"
                @keypress.enter="$event.target.blur"
                @blur="updateAlt(image, $event.target.value, index)"
                :ref="'alt' + index"
              />
            </div>
            <div
              v-else
              key="alt"
            >
              <span class="alt-title">{{ image.alt }}</span>
            </div>
            <span class="pen" v-if="!image.showInput.alt" @click="$emit('toggleShowInput', image, 'alt', index)"><i class="fas fa-pen"></i></span>
          </div><!-- .altBox -->
          <div class="data">
            <div>
              <span class="info-key">更新者</span><span>：{{ image.modifiedUserName }}</span>
            </div>
            <div>
              <span class="info-key">更新日時</span><span>：{{ image.modifiedOn }}</span>
            </div>
            <div>
              <span class="info-key">サイズ</span><span>：{{ Math.ceil(image.filesize / 1024).toLocaleString() }}KB</span>
            </div>
            <div>
            <span class="info-key">横 × 縦</span><span>：{{ width(image) }}px × {{ height(image) }}px</span>
            </div>
          </div>
        </div><!-- .info -->
        <ul class="img-nav" v-if="mixinIsShowAsync">
          <li @click="$emit('showImagePreview', image)">プレビュー</li>
          <li @click="$emit('showImageDetailEditor', image)">編集</li>
          <li @click="$emit('deleteConfirm', image)">削除</li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
import AsyncShowBase from '@/mixins/AsyncShowBase'

export default {
  props: [
    'images',
    'isLogo',
  ],
  mixins: [
    AsyncShowBase
  ],
  computed: {
    width () {
      return function (image) {
        return Number(image.width.replace('px', '')).toLocaleString()
      }
    },
    height () {
      return function (image) {
        return Number(image.height.replace('px', '')).toLocaleString()
      }
    }
  },
  mounted () {
    this.mixinAsyncShow('images')
  },
  methods: {
    updateAlt (image, value, index) {
      image.alt = value
      this.$emit('toggleSave', image, 'alt', index)
    }
  },
}
</script>

<style lang="scss" scoped>
a {
  color: $commonFontColor;
}
.list-view {
  > li {
    padding: 20px;
    padding-right: 0;
    border-bottom: 0.5px solid #C6C6C6;
    margin: 0 20px;
    position: relative;
    &:hover {
      background: rgba($primaryHoverColor, 0.1);
    }
    &:first-of-type {
      border-top: 0.5px solid #C6C6C6;
    }
    // 一括操作のチェックボックス
    .checkbox {
      position: absolute;
      top:20px;
      left: 0;
      input[type=checkbox] {
        display:  none;
        + label {
          font-size: 12px;
          margin-bottom: 0;
          display: inherit;
          line-height: 20px;
          &::before {
            width: 20px;
            height: 20px;
            vertical-align: bottom;
            margin-right: 8px;
            display: inline-block;
            content: '';
            border-radius: 4px;
            background: #cfcfcf;
          }
        }
        &:checked + label::before {
          font-size: 14px;
          box-sizing: border-box;
          font-family: "Font Awesome 5 Free";
          padding-left: 3px;
          content: '\f00c';
          display: inline-block;
          font-weight: 900;
        }
      }
    }
    .box-wrapper {
      margin-left: 20px;
      display:flex;
      align-items: center;
    }
    .image-wrapper {
      background: #e4e4e4;
      border: 0.5px solid #e0e0e0;
      margin: 25px 0 25px 0;
      overflow: hidden;
      display: inline-block;
      img {
        opacity: 0;
        width: 130px;
        height: 130px;
        object-fit: contain;
      }
      img[lazy=loaded] {
        opacity: 1;
      }
    }
    .info {
      max-width: calc(100% - 430px);
      padding: 10px;
      padding-left: 50px;
      display: inline-block;
      flex: 1;
      .id {
        font-size: 12px;
        color: rgba(#484848, 0.6);
        span {
          display: inline-block;
          text-align: center;
          border-radius: 12px;
          background: #e4e4e4;
          width: 30px;
          height: 19px;
          margin-right: 8px;
        }
      }
      .name-box, .alt-box {
        font-size: 16px;
        font-weight: bold;
        display: flex;
        flex: 1;
        > div {
          overflow: hidden;
        }
        .name {
          display: inline-block;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        span {
          cursor: pointer;
          color: rgba($baseFontColor, 0.9);
        }
        .main-input {
          margin-top: 0;
        }
      }
      .alt-box {
        font-weight: normal;
        margin-top: 5px;
        .alt-title {
          display: inline-block;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &::before {
            content: 'alt';
            display: inline-block;
            text-align: center;
            width: 34px;
            height: 24px;
            border-radius: 12px;
            margin-right: 5px;
            background: #e4e4e4;
          }
        }
      }
      input {
        width: 100%;
        background: #e4e4e4;
        padding: 0 5px;
        border-radius: 2px;
        margin-bottom: 10px;
      }
      button {
        display: inline;
      }
      .pen {
        padding-left: 3px;
      }
      .data {
        margin-top: 5px;
        .info-key {
          display: inline-block;
          width: 57px;
        }
      }
    }
    // 右側のメニュー
    .img-nav {
      width: 288px;
      display:flex;
      justify-content: flex-end;
      margin: 0;
      > li {
        width: 96px;
        height: 64px;
        white-space: nowrap;
        font-weight: 300;
        border-radius: 2px;
        transition: all 0.3s ease 0s;
        text-align: center;
        padding-top: 12px;
        cursor: pointer;
        &:hover, &:active {
          background: #e4e4e4;
          transition: all 0.3s ease 0s;
          border-radius: 2px;
        }
        &::before {
          font-family: "Font Awesome 5 Free";
          display: block;
          text-align: center;
        }
        &:nth-of-type(1)::before {
          content: '\f06e';
          font-weight: 900;
        }
        &:nth-of-type(2)::before {
          content: '\f044';
          font-weight: 900;
        }
        &:nth-of-type(3)::before {
          content: '\f2ed';
        }
      }
    }
  }
}
</style>
